const { plugin } = require('twrnc');

module.exports = {
    content: [],
    darkMode: 'media', // or 'media' or 'class'
    theme: {
        screens: {
            sm: '380px',
            md: '420px',
            lg: '680px',
            // or maybe name them after devices for `tablet:flex-row`
            tablet: '1024px',
        },
        extend: {
            colors: {
                // Fondo estándar de la app (pantallas/contenedores).
                background: "#F3F2F3",

                // Elemento seleccionado (ej. un filtro con valor distinto de "Todo"):
                // fondo morado tenue + borde morado más fuerte. bg-selected border-selected-border
                selected: {
                    DEFAULT: "#FBF5FF",
                    border: "#D9C6E4",
                },
                secondary: {
                    50: "#F2DFFC",
                    100: "#E2BAF8",
                    200: "#C574F1",
                    300: "#A82FEA",
                    400: "#7F13B9",
                    500: "#510C76",
                    DEFAULT: "#510C76",
                    600: "#3F095D",
                    700: "#300745",
                    800: "#20052E",
                    900: "#100217",
                    950: "#0A010E"
                },

                primary: {
                    50: "#EAFBF9",
                    100: "#D4F7F4",
                    200: "#AAEEE8",
                    300: "#7FE6DD",
                    400: "#55DDD2",
                    DEFAULT: '#2ad2c5',
                    500: "#2AD2C5",
                    600: "#22AA9F",
                    700: "#198077",
                    800: "#11554F",
                    900: "#082B28",
                    950: "#041514"
                },

                // Ejemplos:
                // Reescribir algún color base
                red: {
                    DEFAULT: '#FF1B51',
                },
                // Agregar un color entero
                // Una buena página para generar 
                'ocean-green': {
                    DEFAULT: '#48BB78',
                    '50': '#EFF9F3',
                    '100': '#DDF2E6',
                    '200': '#B8E4CA',
                    '300': '#92D7AF',
                    '400': '#6DC993',
                    '500': '#48BB78',
                    '600': '#389860',
                    '700': '#2B7249',
                    '800': '#1D4D31',
                    '900': '#0F2819'
                },
            },
        },
    },
    variants: {
        extend: {},
    },
    plugins: [
        plugin(({ addUtilities }) => {
            addUtilities({
                row: {
                    flexDirection: 'row',
                    alignItems: 'center',
                },
            });
        }),
    ],
}
